import React, {createContext, useContext, useState} from 'react';
import useValueChangeListener from "../services/state/general/useValueChangeListener";

const ComponentRegistryContext = createContext({});

export const ComponentRegistryProvider = ({ children, components: passedComponents={} }) => {

    const [ components, setComponents ] = useState( passedComponents );

    const registerComponents = (newComponents) => setComponents({ ...components, ...newComponents });

    return (
        <ComponentRegistryContext.Provider value={{ components, registerComponents }}>
            {children}
        </ComponentRegistryContext.Provider>
    );
};

export const useComponentRegistry = () => useContext(ComponentRegistryContext);

export const ComponentRegistry = ({ components, children }) => {
    const { registerComponents } = useComponentRegistry();

    useValueChangeListener(() => {
        registerComponents(components);
    }, [components], []);

    return (
        <>
            {children}
        </>
    )
}
